import { Network } from '@mprolab/sdk'

/**
 * MPRO token listing banner (top yellow bar): same canonical addresses as production.
 * Source of truth for on-chain verification: Etherscan / Basescan for 0xD886…2273e (MPRO).
 * Update here when token deployment changes — do not reintroduce Contentful for this bar.
 */
export const listingNotificationContracts: { name: string; address: string; chain: Network }[] = [
  {
    name: 'MPRO',
    address: '0xD88611A629265C9AF294FFDD2E7fa4546612273e',
    chain: Network.BASE
  },
  {
    name: 'MPRO',
    address: '0xD88611A629265C9AF294FFDD2E7fa4546612273e',
    chain: Network.ETHEREUM
  }
]
